<template>
  <div style="display: inline-block; margin: 10px;" :style="mainStyle" :data-id="idx">
    <a-spin :spinning="loading">
      <div class="chartMain" style="box-shadow: 0px 0px 6px 1px #449f8d">
        <a-row style="padding: 5px;" >
          <div>
            <a-col :xs="22" :sm="22">
              <a-form-model layout="inline" :model="iOptions">
                <a-form-model-item label="Gráfica" v-show="showHeader !== false">
                  <form-model-dropdown style="min-width: 200px"
                                      endpoint="greports"
                                      :selectedObj.sync="reporteSeleccionado"
                                      :params="reportLovParams"
                                      v-model="iOptions.report_id">
                  </form-model-dropdown>
                </a-form-model-item>
                <a-form-model-item>
                  <a-button icon="setting" size="small" @click="setupVisible = true"
                            v-if="!$isEmpty(reporteSeleccionado)">
                  </a-button>
                  <a-button icon="delete" size="small" @click="$emit('delete', idx)" v-show="showHeader !== false"></a-button>
                </a-form-model-item>
              </a-form-model>
            </a-col>
          </div>
          <div style="position: absolute; top: 5px; right: 10px; margin-top: 5px;z-index: 10;">
            <a-button 
              icon="file-pdf" 
              size="small" 
              type="danger" 
              @click="exportToPDF"
              :loading="exportLoading"
              v-if="!$isEmpty(reporteSeleccionado) && chart && chart.data.labels.length > 0"
            >
              PDF
            </a-button>
          </div>
        </a-row>
        <a-row :style="chartStyle">
          <canvas :id="rnId" width="200" height="200"></canvas>
        </a-row>
        <a-tag color="red" v-if="paramsWarning">* Este reporte tiene parámetros obligatorios.. configúrelos para poder
          visualizar la gráfica
        </a-tag>
      </div>
    </a-spin>
    <a-modal v-model="setupVisible" title="Configurar Gráfica" @ok="configurarGrafica">
      <a-form-model :model="reportParams" ref="reportForm">
        <a-row :gutter="[16,16]">
          <a-col :span="12" :xs="24" :sm="12">
            <a-form-model-item label="Tipo de Gráfico">
              <a-select v-model="iOptions.tipoGrafico" clearable>
                <a-select-option :value="key" v-for="(value, key) in tiposDeGrafico">
                  {{value}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" :xs="24" :sm="12">
            <a-form-model-item label="Ancho Personalizado">
              <a-input-number v-model="iOptions.chartWidth" style="width: 100%;"></a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" :xs="24" :sm="12">
            <a-form-model-item label="Tirulo Personalizado">
              <a-input v-model="iOptions.customTitle" style="width: 100%;"></a-input>
            </a-form-model-item>
          </a-col>

          <template v-if="reporteSeleccionado">
            <template v-for="param in reporteSeleccionado.params">
              <a-col :span="12" :xs="24" :sm="12">
                <a-form-model-item
                  :rules="[{ required: param.required, message: 'Valor requerido' }]"
                  :label="param.label"
                  :prop="param.column"
                  :ref="`fmi${param.column}`">

                  <template v-if="param.h_param_type === tipos.T_LOV">
                    <a-select style="width: 100%"
                              :showSearch="true"
                              :filterOption="filterOption"
                              allowClear
                              v-model="reportParams[param.column]">
                      <a-select-option :value="option.value"
                                       v-for="option in param.items">
                        {{option.label}}
                      </a-select-option>
                    </a-select>
                  </template>
                  <template v-else-if="param.h_param_type === tipos.T_LOV_SQL">
                    <form-model-dropdown style="width: 100%"
                                         v-model="reportParams[param.column]"
                                         endpoint="greports/sql_lov_param_values"
                                         :cache="false"
                                         :params="lovSqlParams[param.column]">
                    </form-model-dropdown>
                  </template>

                  <template v-if="param.h_param_type === tipos.T_NUMBER">
                    <a-input-number v-model="reportParams[param.column]"
                                    @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                    @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                    style="width: 60%"
                    ></a-input-number>
                  </template>

                  <template v-else-if="param.h_param_type === tipos.T_DATE">
                    <a-date-picker style="width: 60%"
                                   v-model="reportParams[param.column]"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                   @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                   format="Y-MM-DD"></a-date-picker>
                  </template>
                  <template v-else-if="param.h_param_type === tipos.T_TEXT">
                    <a-input v-model="reportParams[param.column]"
                             @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                             @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                             style="width: 60%"
                    ></a-input>
                  </template>

                </a-form-model-item>
              </a-col>
            </template>
          </template>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Chart from 'chart.js'
  import HttpUtil from '@/util/HttpUtil'
  import html2canvas from 'html2canvas'
  import jsPDF from 'jspdf'

  export default {
    data () {
      return {
        exportLoading: false,
        /* Tipos sale de: GReport.vue */
        tipos: {
          T_LOV: 'LOV',
          T_TEXT: 'TEXT',
          T_NUMBER: 'NUMBER',
          T_DATE: 'DATE',
          T_LOV_SQL: 'LOV_SQL'
        },
        iOptions: {
          report_id: null,
          reportParams: {},
          tipoGrafico: null,
          chartWidth: null
        },
        labelCol: {span: 4},
        wrapperCol: {span: 20},
        rnId: '',
        loading: false,
        reportes: [],
        reporteSeleccionado: {},
        chart: null,
        setupVisible: false,
        tiposDeGrafico: {
          'bar': 'Barras',
          'line': 'Lineas',
          'pie': 'Torta',
          'radar': 'Radar'
        },
        reportLovParams: {
          chart_reports: true
        },
        reportParams: {},
        lovSqlParams: {},
        paramsTipoSql: {},
        compMounted: false,
        initZero: this.$getConfigValue('INICIALIZAR_GRAFICOS_REPORTES_EN_CERO', 'NO') === 'SI'
      }
    },
    props: ['options', 'height', 'width', 'idx', 'showHeader'],
    mounted () {
      this.httpClient = new HttpUtil()

      if (JsUtils.isEmpty(this.options)) {
        this.$emit('update:options', this.iOptions)
      } else {
        this.iOptions = {...this.iOptions, ...this.options}
        this.reportParams = this.iOptions.reportParams
      }

      if (JsUtils.isEmpty(this.height)) {
        this.$emit('update:height', 300)
      }
      if (JsUtils.isEmpty(this.width)) {
        this.$emit('update:width', 300)
      }

      this.rnId = parseInt(Math.random() * 1000)
      this.$nextTick(() => {
        this.compMounted = true
        this.initChart()
      })
    },
    methods: {
      initChart () {
        this.chart = new Chart(document.getElementById(this.rnId), {
          type: this.tipoGrafico,
          data: {
            labels: [],
            datasets: []
          },
          options: {
            title: {
              display: !JsUtils.isEmpty(this.chartTitle),
              text: this.chartTitle
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  // beginAtZero: true
                }
              }]
            }
          }
        })
      },
      updateChart () {
        if (this.chart.type !== this.tipoGrafico) {
          this.chart.destroy()
          this.initChart()
        }
        this.chart.data.datasets.splice(0, this.chart.data.datasets.length)
        this.chart.data.labels.splice(0, this.chart.data.labels.length)

        if (!this.iOptions.report_id) {
          this.chart.update()
          return
        }
        this.loading = true
        let params = []
        this.reporteSeleccionado.params.map(param => {
          let operator = 'EQUALS'
          let value = this.reportParams[param.column]
          if (!JsUtils.isEmpty(value)) {
            params.push({
              param: param.id,
              operator: operator,
              value: value
            })
          }
        })

        this.httpClient.getInstance().post('analytics/query_report_data', {
          id_g_report: this.iOptions.report_id,
          params: params
        })
          .then(response => {
            response.data.labels.map(label => {
              this.chart.data.labels.push(label)
            })
            response.data.datasets.map(dataset => {
              if (this.initZero) {
                dataset.data.push(0)
              }
              this.chart.data.datasets.push(dataset)
            })
            this.chart.update()
          })
          .catch(error => {
            console.log(error)
          })
          .then(() => {
            this.loading = false
          })
      },
      configurarGrafica () {
        this.$refs.reportForm && this.$refs.reportForm.validate(valid => {
          if (valid) {
            if (this.tmpTipoGrafico) {
              this.tipoGrafico = this.tmpTipoGrafico
            }
            this.updateChart()
            this.setupVisible = false
          }
        })
      },
      async exportToPDF() {
      this.exportLoading = true
      try {
        const canvas = document.getElementById(this.rnId)
        const canvasData = await html2canvas(canvas, {
          scale: 4, 
          backgroundColor: '#ffffff',
          logging: false,
          allowTaint: true,
          useCORS: true,
          imageTimeout: 0,
          onclone: (clonedDoc) => {
          }
        })
        
        const imgData = canvasData.toDataURL('image/png')
        
        const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'pt',
          format: 'a4'
        })
        
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        
        const imgWidth = canvasData.width
        const imgHeight = canvasData.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        
        const width = imgWidth * ratio
        const height = imgHeight * ratio
        
        const x = (pdfWidth - width) / 2
        const y = (pdfHeight - height) / 2
        
        pdf.addImage(imgData, 'PNG', x, y, width, height, undefined, 'FAST') 
        pdf.save(`grafica-${Date.now()}.pdf`)
        
        this.$message.success('PDF exportado con éxito')
      } catch (error) {
        console.error('Error al exportar PDF:', error)
        this.$message.error('Error al exportar el PDF')
      } finally {
        this.exportLoading = false
      }
  }
    },
    computed: {
      mainStyle () {
        return {
          height: `${this.height}px`,
          'min-height': `264px`,
          width: `${this.iOptions.chartWidth || this.width}px`,
          'min-width': `${this.iOptions.chartWidth || this.width}px`
        }
      },
      chartStyle () {
        return {
          height: `${this.height - 64}px`
        }
      },
      chartTitle () {
        if (JsUtils.isEmpty(this.iOptions.customTitle)) {
          if (JsUtils.isEmpty(this.reporteSeleccionado)) {
            return ''
          }
          return this.reporteSeleccionado.name
        }
        return this.iOptions.customTitle
      },
      paramsWarning () {
        if (!JsUtils.isEmpty(this.reporteSeleccionado)) {
          let params = this.reporteSeleccionado.params
          for (let i = 0; i < params.length; i++) {
            const param = params[i]
            if (param.required && JsUtils.isEmpty(this.reportParams[param.column])) {
              return true
            }
          }
        }
        return false
      },
      tipoGrafico () {
        return this.iOptions.tipoGrafico || (this.reporteSeleccionado && this.reporteSeleccionado.tipo_grafica) || 'bar'
      }
    },
    watch: {
      iOptions: {
        deep: true,
        handler () {
          if (this.compMounted) {
            this.$emit('update:options', this.iOptions)
          }
        }
      },
      reporteSeleccionado () {
        if (JsUtils.isEmpty(this.reporteSeleccionado)) {
          return
        }

        let newReportParams = {}

        let paramsTipoSql = {}
        this.reporteSeleccionado.params.map(param => {
          if (param.h_param_type === this.tipos.T_LOV_SQL) {
            paramsTipoSql[param.column] = param.id
          }

          if (!JsUtils.isEmpty(this.reportParams[param.column])) {
            newReportParams[param.column] = this.reportParams[param.column]
          }
        })
        this.paramsTipoSql = paramsTipoSql
        if (!JsUtils.isEqual(this.reportParams, newReportParams)) {
          this.reportParams = newReportParams
        }

        if (!this.paramsWarning) {
          this.updateChart()
        } else {
          if (this.compMounted) {
            this.setupVisible = true
          }
        }
      },
      reportParams: {
        deep: true,
        handler () {
          if (!this.compMounted) {
            return
          }
          let lovSqlParams = {}
          let tmpParams = {}

          for (let prop in this.reportParams) {
            if (this.reportParams.hasOwnProperty(prop)) {
              let propValue = this.reportParams[prop]

              if (!JsUtils.isEmpty(propValue)) {
                tmpParams[prop] = propValue
              }
            }
          }

          for (let prop in this.paramsTipoSql) {
            if (this.paramsTipoSql.hasOwnProperty(prop)) {
              let idParam = this.paramsTipoSql[prop]
              lovSqlParams[prop] = {...tmpParams, id_param: idParam}
            }
          }

          if (!JsUtils.isEqual(this.lovSqlParams, lovSqlParams)) {
            this.lovSqlParams = lovSqlParams
          }

          if (!JsUtils.isEqual(this.reportParams, this.iOptions.reportParams)) {
            this.iOptions.reportParams = this.reportParams
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Analytics/ChartComponent.vue